import React, { Component } from 'react';
import { observer } from 'mobx-react';

import styles from './Home.module.scss';

import Intro from './Sections/Intro/Intro';
import Awards from './Sections/Awards/Awards';
import Management from './Sections/Management/Management';
import NewsAndEvents from './Sections/NewsAndEvents/NewsAndEvents';
import OurProducts from 'common/components/Products/OurProducts';
import OurServices from './Sections/OurServices/OurServices';
import Partners from './Sections/Partners/Partners';
import Departments from './Sections/Departments/Departments';

import ContentStore from 'stores/Content.store';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';

import Placeholder from 'common/components/Placeholder/Placeholder';
import IntroPlaceholder from './Sections/Intro/placeholder/IntroSection/IntroPlaceholder';

@observer
export default class Home extends Component {
  render() {
    const { content } = ContentStore;

    return (
      <div className={styles.Container}>
        {content && (
          <InjectMetaTags {...content.homePageSEO} isHomePage={true} />
        )}
        <Placeholder component={<IntroPlaceholder />} ready={!!content}>
          <Intro buttonUsed={false} />
        </Placeholder>
        <Awards />
        <Management />
        <NewsAndEvents />
        {content && <OurProducts products={content.homePageProducts} />}
        <OurServices />
        <Partners />
        <Departments />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Home.js